import customReportBuilder from '@/reporting/modules/AgGridReports/reducer';

import { combineReducers } from '@reduxjs/toolkit';

export default combineReducers({
  customReportBuilder,
});
